import { createViewerAction } from "../../core/make-action";
import ViewerMethod from "../../core/ViewerMethod";
import { DetailedLoadStatus } from "../../../../../../common/utils/async-status";
import { getBookInfoStatus } from "./selectors";

const fetchBookInfo = createViewerAction(ViewerMethod.GET_BOOK_INFO);

export const fetchBookInfoIfNeeded = () => (dispatch, getState) => {
  if (getBookInfoStatus(getState()) === DetailedLoadStatus.WAITING) {
    return dispatch(fetchBookInfo());
  }
};
